import { ELanguage } from '@microfrontends/app-shell-v2'
import { IStrengthOption, TProfileLevelItem } from '../components/ProfileStrength/const'
export const locationRedirect = (url: string) => {
    window.location.href = url
}

export const locationAssign = (url: string) => {
    window.location.assign(url)
}

export const calculateProfileStrength = (profileLevel: TProfileLevelItem, strengthOption: IStrengthOption[]) => {
    const currentLevelPercentage = (profileLevel.level / strengthOption.length) * 100
    const nextLevelPercentage = ((profileLevel.level + 1) / strengthOption.length) * 100

    const percentage =
        currentLevelPercentage === 100
            ? 100
            : profileLevel.totalPoints > 0
            ? currentLevelPercentage +
              (profileLevel.passedPoints / (profileLevel.totalPoints as number)) *
                  (nextLevelPercentage - currentLevelPercentage)
            : 0

    return percentage
}

export const isMobile = function () {
    return typeof window !== 'undefined' ? window.innerWidth < 769 : false
}

export const getLocalizedOptions = (
    data:
        | {
              id: number
              name: string
              nameEn: string
          }[]
        | null = [],
    langCode
) => {
    return (data || []).map(({ id, name, nameEn }) => ({
        id,
        name: langCode === ELanguage.EN ? nameEn : name
    }))
}

export const removeFileNameExtension = (fileName: string = '', isGetName: boolean = true) => {
    if (fileName === '') {
        return fileName
    }
    // Split by dot
    const fileNameSplitted = fileName.split('.')
    if (fileNameSplitted.length === 0) {
        return fileName
    }
    const extension = fileNameSplitted.pop() ?? ''
    return isGetName ? fileNameSplitted.join('.') : extension
}

export const splitFileExtension = (fileName: string, extension?: string) => {
    const lastDotIndex = fileName.lastIndexOf('.')

    // If there's no dot in the file name, assume no extension
    if (lastDotIndex === -1) {
        return [fileName, extension]
    }

    const name = fileName.slice(0, lastDotIndex)
    const extensionName = fileName.slice(lastDotIndex)

    return [name, extensionName]
}

export const getLocalizedName = (
    data: {
        id: number
        name: string
        nameEn: string
    } | null,
    langCode
) => {
    if (!data) {
        return '-'
    }
    return langCode === ELanguage.EN ? data?.nameEn : data.name
}

export function delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export const checkMissingField = (data: { [key: string]: any }): boolean => {
    return !!Object.entries(data).find(([key, value]) => {
        if (Array.isArray(value)) {
            return value.length === 0
        }
        if (!value) {
            return true
        }
        return false
    })
}
